import React from 'react'

import { HouseStudyDayIndividualSeasonalPriceField } from './components/HouseStudyDayIndividualSeasonalPriceField'
import { Divider } from '../../../../../../../../../../atoms/divider/Divider'
import { HouseStudyDayIndividualFieldProps } from '../../../form-container/HouseStudyDayIndividualFormContainer'

export const HouseStudyDayIndividualSeasonalPricesFields = (
  props: HouseStudyDayIndividualFieldProps,
) => {
  return (
    <>
      <HouseStudyDayIndividualSeasonalPriceField
        {...props}
        name='residential.lowPrice'
      />
      <HouseStudyDayIndividualSeasonalPriceField
        {...props}
        name='fullDay.lowPrice'
      />
      <HouseStudyDayIndividualSeasonalPriceField
        {...props}
        name='halfDay.lowPrice'
      />

      <Divider />

      <HouseStudyDayIndividualSeasonalPriceField
        {...props}
        name='residential.mediumPrice'
      />
      <HouseStudyDayIndividualSeasonalPriceField
        {...props}
        name='fullDay.mediumPrice'
      />
      <HouseStudyDayIndividualSeasonalPriceField
        {...props}
        name='halfDay.mediumPrice'
      />

      <Divider />

      <HouseStudyDayIndividualSeasonalPriceField
        {...props}
        name='residential.highPrice'
      />
      <HouseStudyDayIndividualSeasonalPriceField
        {...props}
        name='fullDay.highPrice'
      />
      <HouseStudyDayIndividualSeasonalPriceField
        {...props}
        name='halfDay.highPrice'
      />
    </>
  )
}
